import { useState, useCallback } from 'react'

const useMap = () => {
  const [map, setMap] = useState<google.maps.Map<Element> | null>(null)
  const onLoad = useCallback(map => setMap(map), [])
  const onUnmount = useCallback(() => setMap(null), [])

  return { map, onLoad, onUnmount } as const
}

export default useMap
